export const SW_VERSION = "d8e997d05408d759cc69ff36f2997502";